<template>
  <div class="hotline" style="min-height:35vw">
    <div class="container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>热线问答</el-breadcrumb-item>
      </el-breadcrumb>

      <!-- 问答 -->
      <el-form ref="form" :model="form" label-position="left" label-width="120px">
        <div class="top-inputs">
          <div class="betweens">
            <span>*</span>
            <el-form-item label="问题类型" style="border: none;background: #fff;">
              <el-select
                v-model="form.category"
                placeholder="请选择"
                value=""
                @change="selectTrigger(form.category)"
              >
                <template v-for="(item,index) in nameList">
                  <el-option :key="index" :label="item.dataName" :value="item.tid"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>

          <div class="betweens">
            <el-form-item label="邀请专家(回答)">
              <el-select v-model="form.expertId" placeholder="请选择" id="experbyId" :value="experbyId">
                <template v-for="(item,index) in exprtList">
                  <el-option :key="index" :label="item.realname" :value="item.userId"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="input-center">
          <p class="input-p">
            <span class="font-color">*</span>
            <span>问题</span>
          </p>
          <input class="input-two" v-model="form.title" type="text" placeholder="请输入问题" />
          <!-- <span style="color:#149508;font-size:12px;">字数不能超过30</span> -->
        </div>

        <div class="input-center flex_box">
          <p class="input-p-textarea">
            <span class="font-color">*</span>
            <span>问题详情</span>
          </p>
          <textarea class="textareas" v-model="form.detail" cols="30"></textarea>
        </div>

        <div class="img-filel">
          <p class="input-p border_bottom">
            <span>图片上传</span>
          </p>
          <el-upload
            class="upload-demo border_bottom"
            accept=".bmp, .jpg, .png"
            :http-request="beforeupload"
            action
            :show-file-list="true"
            :limit="5"
            :on-exceed="handleExceed"
            :on-remove="beforeRemove"
            :on-preview="handlePreview"
            :on-success="handleSuccess"
            :file-list="fileList"
            :multiple="true"
            list-type="picture"
          >
            <el-button class="bton" size="small" type="primary">请选择</el-button>
          </el-upload>
        </div>

        <div class="buttons" type="primary" onselectstart="return false" @click="onSubmit">提交上传</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { host } from "@/api/config";
import axios from "axios";
import cookie from "js-cookie";
export default {
  data() {
    return {
      data: {},
      experbyId:'',
      exprtList: [],
      userId: "",
      username: "",
      telephone: "",
      activeName3: "first",
      dictTypeCode: "question_category",
      form: {
        category: "",
        expertId: "",
        title: "",
        detail: ""
      },
      coverUrl: "",
      formData: "",
      nameList: [],
      fileList: [],
      uploadObj: {}
    };
  },
  computed: {
    hostUrl() {
      return host + "/zs/common/uploadPicture";
    }
  },

  mounted(e) {
    if (cookie.get("user")) {
      let user = cookie.get("user");
      this.userId = JSON.parse(user).tid;
      this.username = JSON.parse(user).username;
      this.telephone = JSON.parse(user).telephone;
      console.log(this.userId);
    } else if (sessionStorage.getItem("user")) {
      let user = sessionStorage.getItem("user");
      this.userId = JSON.parse(user).tid;
      this.username = JSON.parse(user).username;
      this.telephone = JSON.parse(user).telephone;
    }

    this.queryDataDict();
    if (this.userId == "") {
      this.$message({
        message: "您还未登录喔",
        type: "warning"
      });
    }
  },
  methods: {
    uploadErr(err, file, fileList) {
      this.$message({
        type: "error",
        message: "文件上传时出错"
      });
    },
    //类别查询
    queryDataDict() {
      const data = {
        dictTypeCode: this.dictTypeCode
      };
      this.$api.questionApi
        .queryDataDict(data)
        .then(res => {
          console.log("类别=>", res);
          this.nameList = res.data.respData;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 提交问题
    questSubmit() {
      const obj = this.uploadObj;
      let objToList = [];
      for (let i in obj) {
        //遍历对象  i是对象的key  obj[i] 是对象的值
        objToList.push(i);
      }
      var params = new URLSearchParams();
      params.append("userId", this.userId);
      params.append("username", this.username);
      params.append("telephone", this.telephone);
      params.append("category", this.form.category);
      params.append("expertId", this.form.expertId);
      params.append("title", this.form.title);
      params.append("detail", this.form.detail);
      params.append("picList", objToList);
      const data = {
        userId: this.userId,
        category: this.form.category,
        expertId: this.form.expertId,
        title: this.form.title,
        detail: this.form.detail,
        picList: objToList
      };
      console.log("提交表单的图片数组", this);

      this.$api.questionApi
        .question(params)
        .then(res => {
          console.log(res);
          if (res.status == 200 && res.data.respCode!=3) {
            this.$message({
              message: "恭喜你，提交成功",
              type: "success"
            });
          }
        })
        .catch(err => {
          // console.log("err=>", err);
        });
    },

    beforeupload(item) {
      let params = new FormData();
      params.append("userId", this.userId);
      params.append("username", this.username);
      params.append("telephone", this.telephone);
      params.append("token", this.userId);
      params.append("file", item.file);
      this.axios
        .post(
          "https://nongji-img.ahnydsj.com/nongji-api/zs/common/uploadPicture",
          params,
          { headers: { "Content-Type": "multipart/form-data" } }
        )
        .then(res => {
          // console.log(res)
          if (res.data.respCode == 1) {
            const coverUrl = res.data.respMap.fileUrl;
            this.uploadObj[coverUrl] = coverUrl;
            this.$notify({
              title: "Success",
              message: "上传成功！",
              type: "success",
              duration: 2000
            });
            console.log(this.uploadObj);
          } else {
            this.$message.error(res.data.respMsg);
          }
        });
    },
    handleSuccess(res, file) {
      console.log("=======================", res);
    },
    selectTrigger(category) {
      console.log(category);
      this.form.expertId = ''
      if (category != '') {
        this.experbyId = document.getElementById("experbyId").value = ''
        this.expertPage(category);
      }
    },
    // 专家id查询
    expertPage(category) {
      let data = {
        type: category || ""
      };
      this.$api.questionApi
        .queryExpertList(data)
        .then(res => {
          console.log("专家id查询=>", res);
          this.exprtList = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 提交
    onSubmit() {
      let form = this.form;
      if (form.title.length > 30) {
        this.$message({
          message: "问题超过字数限制啦 , 字数不能超过30哦",
          type: "warning"
        });
        return;
      }
      if (form.title.length > 30 || form.detail.length > 200) {
        this.$message({
          message: "问题详情超过字数限制啦 , 字数不能超过200哦",
          type: "warning"
        });
        return;
      }
      if (form.category == "" || form.title == "" || form.detail == "") {
        this.$message({
          message: "必填项不能为空喔",
          type: "warning"
        });
      } else if (!this.userId) {
        this.$message({
          message: "您还未登录喔",
          type: "warning"
        });
      } else {
        this.questSubmit();
        this.$router.push({ path: "/questiontList" });
      }

      // this.$router.push({ path: "/questiontList" });
      console.log(this, "submit!");
    }
  }
};
</script>

<style lang="less" scoped>
.flex_box {
  display: flex;
}
.hotline {
  padding-top: 20px;
}
.top-inputs,
.betweens {
  display: -webkit-flex;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -o-justify-content: space-between;
  -webkit-align-items: center;
  -moz-align-items: center;
  -o-align-items: center;
}
.top-inputs {
  padding-bottom: 20px;
}
.betweens {
  border: 1px solid #e4e4e4;
  padding-left: 10px;
  span {
    padding-right: 5px;
    color: red;
  }
}
.img-filel {
  margin-bottom: 100px;
}
.input-box,
.input-center {
  width: 40%;
  margin-bottom: 20px;
}
.input-box,
.input-center,
.img-filel {
  border: 1px solid #e4e4e4;
  color: #606266;
  .input-p {
    height: 20px;
  }
  .input-p-textarea {
    height: 180px;
    line-height: 180px;
  }
  .input-p,
  .input-p-textarea {
    float: left;
    padding: 10px;
    width: 120px;
    border-right: 1px solid #e4e4e4;
    .font-color {
      color: red;
    }
  }
}
.bton,
.buttons {
  border: none;
  font-size: 16px;
  outline: none;
}
.buttons {
  text-align: center;
  line-height: 45px;
}
.bton {
  background: none;
  color: #999;
  height: 40px;
  padding-left: 15px;
  width: 997px;
  text-align: left;
}
.buttons {
  width: 200px;
  color: #fff;
  background: #149508;
  height: 45px;
  border-radius: 8px;
  margin-left: 100%-60%;
  cursor: pointer;
}
.input-one {
  width: 65%;
}
.input-two {
  width: 70%;
}
input {
  height: 40px;
  font-size: 14px;
  padding-left: 15px;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  color: #c0c4cc;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c0c4cc;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c0c4cc;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #c0c4cc;
}
.textareas {
  width: inherit !important;
  flex: 1;
  height: 200px;
  padding: 15px;
  box-sizing: border-box;
  resize: none;
}
.textareas,
input {
  background: none;
  outline: none;
  border: none;
  color: #606266;
  font-size: 16px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.input-center {
  width: 100%;
}

// 修改elem样式
.el-form-item__label {
  border-right: 1px solid #e4e4e4;
  color: #000;
  line-height: 43px;
}
.el-form {
  padding: 30px;
  margin-top: 20px;
  background: #fff;
}
.el-upload-list__item-name {
  margin-right: 100px;
}
.el-upload-list__item {
  width: 200px;
  float: left;
}
.el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #149508;
}
// .el-input__inner {

// }
.el-form-item {
  margin: 0;
}
// 导航
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
.left-boxs {
  float: left;
}
.right-boxs {
  float: right;
}

.border_bottom {
  border-bottom: 1px solid #e4e4e4;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotline.vue